/*
 * Copyright 2025 Intuition Robotics ltd
 */
import __asset_0 from "@res/icons/icon_cross_s.svg";
import {DB_Patient} from "@app/app-shared/patient";
import * as React from "react";
import {HGap} from "../../widget/HGap";

type Props = {
	patient: DB_Patient
	onDelete: () => void
}

const icon = __asset_0;

export class PatientHandle
	extends React.Component<Props> {

	render() {
		return <div className={'ll_h_c'}
		            style={{
			            backgroundColor: "#f0f2f5", height: 25, paddingLeft: 9, paddingRight: 10, borderRadius: 11,
			            marginRight: 10, marginBottom: 4
		            }}>
			<div style={{flex: 1, fontSize: 14, color: "#6a6b6d", fontWeight: 'normal'}}>{this.props.patient.name}</div>
			<HGap h={10}/>
			<img className='clickable' src={icon} onClick={this.props.onDelete} alt={"close"}/>
		</div>;
	}

}
